import { render, staticRenderFns } from "./DotMenu.vue?vue&type=template&id=a99f8de0&scoped=true&"
import script from "./DotMenu.vue?vue&type=script&lang=js&"
export * from "./DotMenu.vue?vue&type=script&lang=js&"
import style0 from "./DotMenu.vue?vue&type=style&index=0&id=a99f8de0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99f8de0",
  null
  
)

export default component.exports